/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Document_DeletedInputs */

const cs_enum_document_deleted = /** @type {(inputs: Enum_Document_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument smazán`)
};

const en_enum_document_deleted = /** @type {(inputs: Enum_Document_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document deleted`)
};

/**
* | output |
* | --- |
* | "Document deleted" |
*
* @param {Enum_Document_DeletedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_document_deleted = /** @type {((inputs?: Enum_Document_DeletedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Document_DeletedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_document_deleted(inputs)
	return cs_enum_document_deleted(inputs)
});